// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1893":"996943ca","3376":"3692fdd8","5351":"3692fdd8"}[chunkId] + ".chunk.css";
};